module.exports = __webpack_public_path__ + "static/media/powerbi.584af8c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/powerbi.png
// module id = 188
// module chunks = 0